<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: Template
  Reason: "uf-Erfassung" tab of the unified xx Side-Car Playground. Runs the
          one-form CREATE flow: a single "uf-Flow starten" submit creates a NEW
          XxPerson together with all three side-cars (#3 intern, #4 extern flach,
          #5 extern typisiert) via the embedded <mvs-uf-flow> runtime. No person
          selector — the flow CREATES the person (TM-1000001960).
-->
@if (initialized) {
    <div class="flex flex-column gap-3 p-3">

        <!-- Tab header -->
        <div class="flex flex-column gap-1">
            <h2 class="m-0">uf-Erfassung</h2>
            <span class="text-color-secondary">
                Dieses Formular legt in einem Schritt eine neue Person samt aller Side-Cars
                (#3 intern, #4 extern flach, #5 extern typisiert) an. Nach dem Absenden erscheinen
                die Daten in den Tabs „QL-Demos“ und „Widgets“. Pflichtfelder und
                Side-Car-Validierungen (z. B. Breite ≤ 1000) werden geprüft.
            </span>
        </div>

        <!-- Load / start error -->
        @if (errorMessage) {
            <p-message severity="error" [text]="errorMessage" styleClass="w-full"></p-message>
        }

        <!-- Flow type not seeded yet -->
        @if (flowTypeId == null && !errorMessage) {
            <p-message
                    severity="warn"
                    text="uf-Flow noch nicht geseedet — bitte später erneut versuchen."
                    styleClass="w-full">
            </p-message>
        }

        <!-- Start view: start button (hidden while a flow runs) -->
        @if (!ufFlowObjectIdentifier) {
            <p-panel header="Neue Person anlegen">
                <div class="flex flex-column gap-3">
                    <span class="text-color-secondary">
                        Starten Sie den Erfassungs-Flow. Im Formular erfassen Sie Vor- und Nachname
                        der neuen Person sowie die Side-Car-Daten — alles wird mit einem Absenden
                        gemeinsam angelegt.
                    </span>
                    <div>
                        <p-button
                                label="uf-Flow starten"
                                icon="fa-light fa-play"
                                [loading]="starting"
                                [disabled]="starting || flowTypeId == null"
                                (onClick)="startFlow()">
                        </p-button>
                    </div>
                </div>
            </p-panel>
        }

        <!-- Running flow: embedded uf runtime -->
        @if (ufFlowObjectIdentifier) {
            <p-panel header="uf-Flow">
                <div class="flex flex-column gap-2">
                    <span class="text-color-secondary">
                        Füllen Sie das Formular aus. Beim Absenden werden die neue Person und ihre
                        Side-Cars (#3/#4/#5) gemeinsam angelegt und können in den Tabs „QL-Demos“ und
                        „Widgets“ abgerufen werden.
                    </span>
                    <mvs-uf-flow
                            [objectIdentifier]="ufFlowObjectIdentifier"
                            [fullPage]="false"
                            (onFlowComplete)="onFlowComplete($event)"
                            (onFlowCancelled)="onFlowCancelled($event)">
                    </mvs-uf-flow>
                </div>
            </p-panel>
        }

    </div>
}
